import superjson from 'superjson';

export interface SecretInput {
  label: string;
  value?: string;
  delete?: boolean;
}

export const postSecret = async (
  body: SecretInput,
  init?: RequestInit,
): Promise<{ success: boolean; label: string }> => {
  const res = await fetch('/_api/taskingbot/secrets', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: superjson.stringify(body),
    ...init,
  });

  const text = await res.text();
  let data: any;
  try {
    data = superjson.parse(text);
  } catch {
    data = JSON.parse(text);
  }

  if (!res.ok) {
    throw new Error(data?.error || `Failed to save secret (HTTP ${res.status})`);
  }

  return data;
};
